import { MayNull } from '@apeiron/temp'
import { useEffect } from 'react'

const useOnClickOutside = (
  element: MayNull<HTMLElement>,
  handler: () => void
) => {
  useEffect(() => {
    if (!element) {
      return
    }

    const listener = (event: MouseEvent) => {
      if (element.contains(event.target as Node)) {
        return
      }

      handler()
    }

    document.addEventListener('click', listener)

    return () => {
      document.removeEventListener('click', listener)
    }
  }, [element, handler])
}

export default useOnClickOutside
